module.exports = __webpack_public_path__ + "static/c2-8bba3e1b4f272970a8ab50a70b90378c.jpeg";